<!-- Header section -->
<login-header></login-header>

<div class="calendly_container">
    <!-- Calendly inline widget begin -->
    <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script>
    <iframe 
        src="https://calendly.com/familycentral" 
        width="100%" 
        height="600px" 
        title="Calendly Content"
        style="overflow:auto; border: none;">
    </iframe>
    <!-- Calendly inline widget end -->
</div>

<!-- Footer section -->
<app-footer></app-footer>